import React from 'react'
import { Route } from 'react-router'
import EndUserInfo from 'components/customer/EndUserInfo'
import * as PlaybookActions from 'app/modules/playbook/actions'
import { PlaybookStatus } from 'app/modules/playbook/constants'

const EndUserRoutes = store => (
  <Route path="users" onEnter={() => {
    store.dispatch(PlaybookActions.searchPlaybooks([PlaybookStatus.ENABLED]))
  }}>
    <Route path=":endUserId" component={EndUserInfo} />
  </Route>
)

export default EndUserRoutes



// WEBPACK FOOTER //
// ./src/scripts/app/routes/EndUserRoutes.js